module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-d6fc60093ff533502312a4a26972a875.svg";